import * as React from 'react';
/**
 *
 * Original name: password strength strong
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=52249%3A41
 *
 */
export const PasswordStrengthStrongLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M4.34 15c-.227-.881-.34-1.88-.34-3 0-5.127 2.374-7.745 7.25-7.982v4.526C9.401 8.774 8.5 9.91 8.5 12c0 .314.02.607.061.878L4.341 15ZM20 12c0 1.12-.113 2.119-.34 3l-4.221-2.122c.04-.271.061-.564.061-.878 0-2.09-.901-3.227-2.75-3.456V4.018C17.626 4.255 20 6.873 20 12Zm-5.086 2.297c-.561.807-1.528 1.203-2.914 1.203-1.386 0-2.353-.396-2.914-1.203l-4.232 2.12C6.019 18.82 8.386 20 12 20s5.981-1.18 7.147-3.583l-4.233-2.12Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
